import React, {useEffect, useState} from "react";
import Modal from "../modal";
import UserForm from "../user-form";
import HOne from "../h-one";


import './offer-resale-list-style.css';
function OfferResaleList(props) {

    let {saveState, dictionary, width, resales = false, projectData,
        isVisible, closeModal, selectedCountry, country
    } = props;
    let data = projectData.listings

    // const [isVisible, setIsVisible] = useState(false);
    const [contactForm, setContactForm] = useState({
        userFullName: '',
        userPhone: '',
        userEmail: '',
        userMessage: '',
        project: projectData.name + ' - List My Unit'
    });

    // const closeModal = () => {
    //     setIsVisible(false);
    // }

    const clearForm = () => {
        setContactForm({
            userFullName: '',
            userPhone: '',
            userEmail: '',
            userMessage: '',
            project: projectData.name + ' - List My Unit'
        });
    };

    const handleInput = (e) => {
        setContactForm({
            ...contactForm,
            [e.target.name]: e.target.value
        });
    }


    const renderModal = () => {
            const words = dictionary.list_your_unit_in_project.toUpperCase().split(' ');
            return(
                <>
                    <HOne addclass={"xsmall"} align={"center"} title={`${words.slice(0, -1).join(' ')} <br/> ${words.slice(-1)} `}  line={"none"} />
                    <img src={projectData.logo === null ? null : `https://ngirealty.com/img/projects/${projectData.id}/${projectData.logo}`} className={"ProjectLogo"} alt=""></img>
                    {data.urgency ?
                        <React.Fragment>
                            <svg xmlns="http://www.w3.org/2000/svg" width="138.247" height="2" viewBox="0 0 138.247 2">
                                <defs>
                                    <linearGradient id="linear-gradient" y1="0.5" x2="1" y2="0.5" gradientUnits="objectBoundingBox">
                                        <stop offset="0" stopColor="#a96903" />
                                        <stop offset="0.258" stopColor="#aa6a02" />
                                        <stop offset="0.352" stopColor="#b07102" />
                                        <stop offset="0.418" stopColor="#b97d02" />
                                        <stop offset="0.472" stopColor="#c78e01" />
                                        <stop offset="0.518" stopColor="#daa401" />
                                        <stop offset="0.557" stopColor="#f0be00" />
                                        <stop offset="0.579" stopColor="#ffd100" />
                                        <stop offset="1" stopColor="#a96903" />
                                    </linearGradient>
                                </defs>
                                <br/>
                                <g id="Сгруппировать_94" data-name="Сгруппировать 94" transform="translate(-2822.173 274.933)">
                                    <rect id="Прямоугольник_18" data-name="Прямоугольник 18" width="138.247" height="2" transform="translate(2822.173 -274.933)" fill="url(#linear-gradient)" />
                                </g>
                            </svg>
                            <br/>
                            <div className={"FormText"}>
                                {data.urgency}
                            </div>
                        </React.Fragment>
                        : (null)
                    }
                    <UserForm
                        closeModal={closeModal.bind(this)}
                        className="MobileMessageModal"
                        thankModal={true}
                        inputBans={{ comment: false, message: true, email:false }}
                        clearForm={clearForm}
                        message={dictionary.thank_you_deal}
                        initialMessage={`${dictionary.send_me_more_details_about_project} ${data.name}`}
                        selectedCountry={selectedCountry}
                        // saveCurrentSelectedCountry={this.saveCurrentSelectedCountry}
                        country={country}
                        topPartRow={true}
                        contactForm={contactForm}
                        handleInput={handleInput}
                        width={width}
                        secureInfo={true}
                        dictionary={dictionary}
                        style={{ textAlign: 'center', justifyContent: 'center' }}
                    />
                    <div className='CoverBlock'>
                        <img src={`https://ngirealty.com/img/projects/${projectData.id}/${projectData.cover_image}`} alt='cover' className='CoverImage' />
                    </div>
                </>
                
            )
        
    }

    return(
         <>
            <Modal

                ModalBlurStyle={{ backgroundColor: "rgba(0,0,0,0.85)" }}
                closeColor={'#000'}
                speed={0.5}
                ModalStyle={{ justifyContent: 'center', flexDirection: 'column', padding: "20px", alignItems: 'center' }}
                modalClass={'MessageModal'}
                closeModal={closeModal}
                isVisible={isVisible}
            >   
                <div className={"OfferResaleListContainer"} style={{textAlign:'center'}}>
                    {renderModal()}
                </div>                               

            </Modal>
        </>
    )

}

export default OfferResaleList;